import { Storage } from 'aws-amplify';
import Utils from '@utils/index';

async function getThumbnailImageLink(path: string): Promise<string> {
  try {
    const url = await Storage.get(Utils.S3.getKey(path), {
      bucket: process.env.REACT_APP_DOWNLOAD_IMAGES_S3_BUCKET || "",
      download: false,
      contentDisposition: "attachment"
    }) as string;
    
    return url;
  } catch (error) {
    throw error;
  }
}

export default getThumbnailImageLink;
